<template>
  <span class="button__icon">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 16 16"
      xml:space="preserve"
      width="16"
      height="16">
      <g
        class="nc-icon-wrapper"
        fill="#ffffff">
        <g
          class="nc-loop_circle-02-16"
          transform="rotate(142.20571429360592 8 8)">
          <path
            opacity="0.4"
            :fill="color"
            d="M8,16c-4.4111328,0-8-3.5888672-8-8s3.5888672-8,8-8s8,3.5888672,8,8S12.4111328,16,8,16z M8,2C4.6914062,2,2,4.6914062,2,8s2.6914062,6,6,6s6-2.6914062,6-6S11.3085938,2,8,2z"/>
          <path
            data-color="color-2"
            :fill="color"
            d="M16,8h-2c0-3.3085938-2.6914062-6-6-6V0C12.4111328,0,16,3.5888672,16,8z">
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 8 8"
              to="360 8 8"
              dur="0.5s"
              repeatCount="indefinite"/>
          </path>
        </g>
      </g>
    </svg>
  </span>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#ffffff'
    }
  }
}
</script>
